module.exports = function apiKey(key) {
    const crypto = require('crypto');
    return (req, res, next) => {
        const reqKey = req.headers['x-api-key'] || (req.query && req.query.api_key);
        const a = Buffer.from(reqKey || '');
        const b = Buffer.from(key || '');
        if (reqKey && a.length === b.length && crypto.timingSafeEqual(a, b)) {
            return next();
        }
        if (res.json) return res.json({ error: 'Invalid API Key' }, 401);
        res.writeHead(401, { 'Content-Type': 'application/json' });
        res.end(JSON.stringify({ error: 'Invalid API Key' }));
    };
};
